import { useState } from "react";

const Fold = () => {
  const [understood, setUnderstood] = useState(false);

  return (
    <>
      <a href="/">
        <img
          className="dreamland__peach"
          src="assets/peach-outline.png"
          alt="PEACH"
        />
      </a>
      <section className="dreamland__fold-wrapper active">
        <div>
          <h1>
            <b>Hello Friends & Dreamers of Dreamland!!</b>
          </h1>
          <br /> <br />
          We're bringing Dreamland to FOLD on Oct 24. I wanted to try Dreamland
          in a larger space, mostly to book some friends to join me which I
          can't always do at the smaller parties AND to see if we could fill
          this space with dreamland qts & dreamers &#60;3
          <br /> <br />
          There's something special that comes with the intimacy of a smaller
          party that is hard to translate into a room with hundreds of people.
          My question is - if we set some intentions about how to show up, and
          have someone talking to people at the door & protecting the space, can
          we try to emulate this intimate feeling on a larger scale?
          <br /> <br />
          Initially, this event was going to be sold only through dreamland
          channels but we have decided to open it up further - our dream is that
          with these intentions in place, we can bring together a crowd that
          gets it no matter who you are.… i hope you’ll join us for giving it a
          whirl n twirl &#60;3
          <br /> <br />
          Peach xoxo
          <br /> <br />
          <br /> <br />
          AND HERE WE HAVE … the proceedings of the DREAMLAND party manifesto.
          To ensure a safer space, for all to get lost to the music and divine
          lights of Cannings Towns pulsing beat (FOLD).
          <br /> <br />
          PLEASE READ AND AGREE TO THIS BEFORE YOU DECIDE TO BUY A TICKET
          &#60;3
          <br /> <br />
          <ul className="dreamland__manifesto">
            <li>
              DREAMLAND prioritises POC, QUEERZ, NBZ, DOLLS, DYKEs and BI's. +
              all inbetween… NO discrimination of any kind. Remember where it
              all started and educate yourself!!!
            </li>
            <br /> 
            <li>
              We will have a door person to speak to upon entry to ensure
              diversity and general vibe control - be aware of what you are
              bringing to the party, how you show up, and be yourself upon
              entry.Our door person reserves the right to refund anyone that
              doesn't align with our values.
            </li>
            <br /> 
            <li>
              Cis men - large groups of straight cis men together will not be
              allowed entry. Please join up with your femme and queer friends to
              come into the event! This isn't the spot for your lads night out…
              sorry!
            </li>
            <br /> 
            <li>
              Having said that, we are happy to accept solo clubbers of all
              genders! You may be asked a few questions on entry.
            </li>
            <br /> 
            <li>
              Dreamland is a party that prides itself on not taking itself too
              seriously!!!! Wear what you feel cute in and dance however you
              like (but respectfully)
            </li>
            <br /> 
            <li>
              We want people to show up, and really show up for who they are, to
              find themselves or one another in comfort and consent.
            </li>
            <br /> 
            <li>
              Space is grace and in that space you find yourself and
              others…remember that! Considering who you are and how you take up
              space is key to a good party and the comfort of others. Be aware
              of the space you take up.
            </li>
            <br /> 
            <li>
              As for party favours, some of us do and some of us don't, some of
              us embrace party accessories to see us into the morning light, but
              remember that the main event is the music and community. Take care
              of yourself and others, hydration is keY!!!
            </li>
            <br /> 
            <li>
              In the case that you overdo it, we have welfare staff around and a
              welfare area for you to hangout in. 0 judgement from our welfare
              team so please don't hesitate if you need something.
            </li>
            <br /> 
            <li>
              Take care of your fellow dreamers! Talk to someone you've never
              spoken to before!! Be open to meeting people IRL and connecting in
              the smoking area or in the dance !!! live ur sweet little LIFE
              !!!!
            </li>
            <br /> 
            <li>
              IF YOU NEED ANY CLARIFICATION ON THIS, PLEASE EMAIL <a href="mailto:missdreamland666@gmail.com">
                MISSDREAMLAND666@GMAIL.COM
              </a>{" "}
              BEFORE YOU BUY A TICKET!!!!
            </li>
          </ul>
        </div>

        <div className="dreamland__understood-wrapper">
          {!understood ? (
            <button
              className="dreamland__understood-button"
              onClick={() => setUnderstood(true)}
            >
              I understand.
            </button>
          ) : (
            <div className="dreamland__understood">
              Ticket link:{" "}
              <a
                href="https://ra.co/events/2497517?p=666-dreamland"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ra.co/events/2497517?p=666-dreamland
              </a>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Fold;
